import { EventArtistRiderTypeEnum } from '../../generated/graphql';
import * as Attachment from '../Attachment/Attachment';
import { take } from '../../util';
export const EventArtistRiderType = Object.freeze({
    HOSPITALITY: EventArtistRiderTypeEnum.Hospitality,
    TECH: EventArtistRiderTypeEnum.Tech,
});
export const fromGql = (item) => {
    var _a;
    return (Object.assign(Object.assign({}, take(item, 'id', 'notes', 'artistLoadInTime', 'stageSoundCheckTime', 'soundCheckType', 'stagePerformersNumber', 'backstagePassesNumber')), { riderType: item.riderType, attachments: ((_a = item.attachments) === null || _a === void 0 ? void 0 : _a.map(Attachment.fromGql)) || [] }));
};
//# sourceMappingURL=EventArtistRider.js.map